<div class="table-responsive" >
  <table *ngIf="concepts.length>0" class="table table-hover table-sm align-middle border border-secondary rounded-4">
    <thead class="table-primary text-center">
      <tr>
        <th>Código</th>
        <th>Concepto</th>
        <th>Voto</th>
        <th>Gastos</th>
        <th>Valor Rendido</th>
        <th>Valor a Pagar</th>
        <th>Comentario del usuario</th>
        <th>Estado</th>
        <th *ngIf="userRole=='Administrador'&& userCanEdit">Corrección</th>
        <th>Acciones</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let c of concepts" class="text-center">
        <td class="form-label-sm">{{ c.concept.code }}</td>
        <td class="form-label-sm">{{ c.concept.name }}</td>
        <td class="form-label-sm">{{ c.vote }}</td>
        <td class="form-label-sm">
          <button class="btn btn-primary btn-sm me-1" title="Ver Archivos" (click)="openFilesModal(c)">
            <i class="fa fa-file"></i>
          </button>
        </td>
        <td class="form-label-sm">${{ c.value | number:'1.0-0':'es-ES' }}</td>
        <td class="form-label-sm">${{ c.valueToPay | number:'1.0-0':'es-ES' }}</td>
        <td class="form-label-sm">{{ c.comment }}</td>
        <td>
          <!--  <span class="badge" [ngClass]="c.isCorrect ? 'bg-success' : 'bg-danger'">
          {{ c.isCorrect ? 'Correcto' : 'Incorrecto' }}
        </span> -->
          <span class="badge" [ngClass]="
          c.isCorrect === true ? 'bg-success' :
         c.isCorrect === false ? 'bg-danger' : 'bg-secondary'">
            {{
            c.isCorrect === true ? 'Correcto' :
            c.isCorrect === false ? 'Incorrecto' : 'Sin definir'
            }}
          </span>
        </td>

        <td *ngIf="userRole=='Administrador' && userCanEdit">
          <!-- Aprobar concept response-->
          <button class="btn btn-success btn-sm me-1" title="Aprobar" (click)="onApproveConcept(c)">
            <i class="fa fa-check"></i>
          </button>
          <!-- Rechazar concept response-->
          <button class="btn btn-danger btn-sm me-1" title="Rechazar" (click)="onRejectConcept(c)">
            <i class="bi bi-x"></i>
          </button>
        </td>
        <td>
          <button class="btn btn-warning btn-sm me-1" title="Editar" (click)="onEditConcept(c)">
            <i class="bi bi-pencil-square"></i>
          </button>
          <button class="btn btn-danger btn-sm" title="Eliminar" (click)="onDeleteConcept(c)"
            [disabled]="!this.userCanEdit ">
            <i class="bi bi-trash"></i>
          </button>
        </td>
      </tr>
    </tbody>
  </table>

</div>


<div *ngIf="concepts.length==0">
  <p>
    No se han cargado conceptos para este reporte, cargue nuevo conceptos desde la pestaña "Conceptos"
  </p>
</div>

<div #listAttachmentsModal class="modal fade" tabindex="-1">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Archivos Adjuntos</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="closeListAttachmentsModal()"></button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-12">
            <table>
              <thead>
                <tr>
                  <th>Nombre</th>
                  <th>Gasto</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let file of attachments">
                  <td>{{ file.fileName }}</td>
                  <td>{{ file.expense.description }}</td>
                  <td>
                    <button class="btn btn-warning btn-sm" (click)="onOpenAttachment(file._id)">
                      <i class="fas fa-eye "></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeListAttachmentsModal()">Cerrar</button>
      </div>
    </div>
  </div>

</div>

<!-- <div #attachmentsModal let-modal>
>>>>>>> origin/development
  <div class="modal-header">
    <h5 class="modal-title text-primary" id="viewAttachmentModalLabel">Visor de Adjuntos</h5>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Cerrar"
      ></button>

  </div>

  <div class="modal-body">
    <app-attachment-viewer>
    </app-attachment-viewer>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary">Cerrar</button>

  </div>
</div>
    <button type="button" class="btn btn-secondary" >Cerrar</button>
  </div>
</div> -->

<div #attachmentViewerModal class="modal fade" tabindex="-1">
  <div class="modal-dialog  modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title text-primary" id="viewAttachmentModalLabel">Visor de Adjuntos</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Cerrar"></button>
      </div>

      <div class="modal-body">
        <app-attachment-viewer>
        </app-attachment-viewer>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeAttachmentViewerModal()">Cerrar</button>
      </div>
    </div>
  </div>

</div>